<!--  SECCION BANNERS -->
<div class="container d-none d-md-block">
  <div id="carouselBC" class="carousel slide" data-ride="carousel">

    <ol class="carousel-indicators" *ngIf="banners.length > 1">
      <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
          [ngClass]="(i === 0) ? 'active' : 'inactive'"></li>
    </ol>

    <!-- ------------------DETALLE PROMOCION >= Medium-Devices ----------------------->
    <div class="carousel-inner d-none d-md-block" style="cursor:pointer;">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
           [ngStyle]="{background: 'url(' + banner.urlImagen +')', 'background-repeat': 'no-repeat', 'background-size': '100% 100%'}"
           [ngClass]="(i === 0) ? 'active' : 'inactive'"  (click)="showCampaign(banner.idCampEspecial, banner.urlExterna, banner.nombre, banner.comercio.nombre)"
           [title]="getInnerHTML(banner.nombre)" [attr.dir]="banner.urlExterna" [attr.content]="banner.urlImagen">
        <div class="container">
          <div class="row">

            <div class="col-12">
              <div class="row" style="height: 400px;">
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- ---------END---------DETALLE PROMOCION >= Medium-Devices ----------------------->

    <!--<div class="container d-none d-lg-block" *ngIf="banners.length > 1">
      <a class="carousel-control-prev" href="#carouselBC" role="button" data-slide="prev" style="left: -8%;">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselBC" role="button" data-slide="next" style="right: -8%;">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>-->

    <!--<div class="container d-block d-lg-none" *ngIf="banners.length > 1">
      <a class="carousel-control-prev" href="#carouselBC" role="button" data-slide="prev" style="left: 0%;">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselBC" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>-->

  </div>

</div>



<!-- ------------------DETALLE PROMOCION == Small-Devices ----------------------->
<div class="d-none d-sm-block d-md-none">
  <div id="carouselBC" class="carousel slide" data-ride="carousel" style="height: 350px;">

    <ol class="carousel-indicators">
      <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
          [ngClass]="(i === 0) ? 'active' : 'inactive'"></li>
    </ol>


    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
           [ngStyle]="{background: 'url(' + banner.urlImagenMovil +')', 'background-repeat': 'no-repeat', 'background-size': '100% 90%'}"
           [ngClass]="(i === 0) ? 'active' : 'inactive'" (click)="showCampaign(banner.idCampEspecial, banner.urlExterna, banner.nombre, banner.comercio.nombre)"
           [title]="getInnerHTML(banner.nombre)" [attr.dir]="banner.urlExterna" [attr.content]="banner.urlImagen">
        <div class="container">
          <div class="row">

            <div class="col-12">
              <div class="row" style="height: 400px;">
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  </div>
</div>
<!--  ENDS SECCION  BANNERS-->


<!-- ------------------DETALLE PROMOCION == Xtra-Small-Devices ----------------------->
<div class="d-block d-sm-none">
  <div id="carouselBC" class="carousel slide" data-ride="carousel" style="height: 380px;">

    <ol class="carousel-indicators">
      <li data-target="#carouselBC" attr.data-slide-to="{{i}}" *ngFor="let banner of banners; let i = index"
          [ngClass]="(i === 0) ? 'active' : 'inactive'" ></li>
    </ol>


    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let banner of banners; let i = index"
           [ngStyle]="{background: 'url(' + banner.urlImagenMovil +')', 'background-repeat': 'no-repeat', 'background-size': '100% 95%'}"
           [ngClass]="(i === 0) ? 'active' : 'inactive'" (click)="showCampaign(banner.idCampEspecial, banner.urlExterna, banner.nombre, banner.comercio.nombre)"
           [title]="getInnerHTML(banner.nombre)" [attr.dir]="banner.urlExterna" [attr.content]="banner.urlImagen">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="row" style="height: 400px;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>
<!--  ENDS SECCION  BANNERS-->
